import { render, staticRenderFns } from "./TemplatePlaceholdersList.vue?vue&type=template&id=0444869e"
import script from "./TemplatePlaceholdersList.vue?vue&type=script&lang=js"
export * from "./TemplatePlaceholdersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports